import $ from 'jquery';
import lodash from 'lodash';
import {geoAddressSearch, geoCitySearch} from '../queries';

const renderItem = ({ name, fiasId, lat, lng, index }, isFiller = false) => {
    const className = isFiller ? 'ui-geo-search__item ui-geo-search__item--filler' : 'ui-geo-search__item js-map-pickpoint-set';

    return (`
        <div class="${className}" data-name="${name}" data-fias-id="${fiasId}" data-lat="${lat}" data-lng="${lng}" data-index="${index}">${name}</div>
    `);
};

const getItems = lodash.debounce(async function ($component) {
    const value = $component.find('.ui-geo-search__control').val();
    const $items = $component.find('.ui-geo-search__items');
    const response = await geoAddressSearch(value,true);
    if (!response.isSuccess || response.items.length === 0) {
        $items.html(renderItem({
            name: 'Ничего не найдено'
        }, true));
    } else {
        $items.html(response.items.map(item => renderItem(item)));
    }
}, 300);

$('.ui-geo-search__clear').click(function () {
    $(this).parents('.ui-geo-search').find('.ui-geo-search__control').val('').trigger('keyup');
    $(this).parents('.ui-geo-search').removeClass('ui-geo-search--opened');
});

$('.js-map-pickpoint-search').keyup(function () {
    const $control = $(this);
    const $component = $control.parents('.ui-geo-search');
    const value = $control.val();
    if (value) {
        $component.addClass('ui-geo-search--filled');
    } else {
        $component.removeClass('ui-geo-search--filled');
    }
    $component.find('.ui-geo-search__items').html(renderItem({
        name: 'Поиск...'
    }, true));
    getItems($component);
}).focus(function (e) {
    $(this).parents('.ui-geo-search').addClass('ui-geo-search--opened');
}).blur(function () {
    setTimeout(() => {
        $(this).parents('.ui-geo-search').removeClass('ui-geo-search--opened');
   }, 200)
});
